module.exports = __webpack_public_path__ + "img/dp-dy-sh10.58d23085.png";